import React, { useEffect, useState, useRef, useCallback } from 'react';
import LockedContent from 'components/LockedContent';
import {
  SmallVideoIcon,
  SmallImageIcon,
  DotsIcon,
  DisabledCommentDotsIcon,
  PostHeartIcon,
} from '../../components/Icons';
import PostHeader from 'components/generic-components/post/PostHeader';
import { renderTime } from 'utils/functions';
import { Dropdown } from 'react-bootstrap';
import NoifyModal from 'components/NotifyModal';
import { useDispatch, useSelector } from 'react-redux';
import { selectAuthUser } from 'reducers/auth/auth.selectors';
import { useTranslation } from 'react-i18next';
import ReportModal from 'components/ReportModal';
import PostActionItem from 'components/generic-components/post/PostActionItem';
import TipModal from 'components/TipModal';
import PostDescription from 'components/generic-components/post/PostDescription';
import { isVideo } from '../../helpers';
import AddPaymentModal from 'components/AddPaymentModal';
import { bookmarkToggle } from 'reducers/feed/feed.actions';
import { fetchFeed, registeredCard } from '../../reducers/feed/feed.actions';

const LockedSubscribeContent = ({ userStatus, onSubmit, FollowBtn, post, files = [], card }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [show, setShow] = useState(false);
  const dispatch = useDispatch();

  const user = useSelector(selectAuthUser);
  const { t } = useTranslation();

  const time = renderTime(post.createdAt);
  // const [card, setCard] = useState(false);

  const handleClose = () => {
    setIsOpen(false);
    window.location.reload();
  };
  useEffect(() => {
    // dispatch(registeredCard()).then(
    //   (resp) => {
    //    setCard(resp)
    //   }
    // )
  }, []);
  const MoreMenuBtn = React.forwardRef(({ children, onClick }, ref) => (
    <div
      ref={ref}
      onClick={e => {
        e.preventDefault();
        onClick(e);
      }}
    >
      <DotsIcon width={24}>{children}</DotsIcon>
    </div>
  ));

  const handleBookmarkToggle = id => {
    dispatch(bookmarkToggle(id));
  };

  const handleShowPaymentModal = () => {
    setShow(true);
  }

  const convertMS = duration => {
    const sec = parseInt(duration, 10);
    let hours = Math.floor(sec / 3600);
    let minutes = Math.floor((sec - hours * 3600) / 60);
    let seconds = sec - hours * 3600 - minutes * 60;
    if (minutes < 10) {
      minutes = '0' + minutes;
    }
    if (seconds < 10) {
      seconds = '0' + seconds;
    }
    return minutes + ':' + seconds;
  };

  return (
    <div className="post-sub-locked">
      <div className="post-locked-container d-flex justify-content-between">
        <PostHeader showSubscribe={true} post={post} />

        <NoifyModal
          show={isOpen}
          onHide={handleClose}
          customClass="notification-modal"
          Content="The content that you are trying to react to is no longer available"
          title="Content no longer avaliable"
        />

        <div className="heb-date-ago cursor-pointer d-flex">
          <p className="heb-date mr-2 mt-1 font-size-12 ml-auto text-gray">
            {time.actualTime} {t(`${time.text}`)}
          </p>
          {/**       
           {!!user && (
            <Dropdown alignRight={true} className={' post-header-dropdown'}>
              <Dropdown.Toggle as={MoreMenuBtn}></Dropdown.Toggle>
              <Dropdown.Menu className={'posts-dropdown font-size-12 border-radius-modal'}>
                {post.user.id === user.id ? (
                  <React.Fragment>
                    <Dropdown.Item>
                      {post.pinnedAt ? t('Unpin to top on your profile page') : t('Pin to top on your profile page')}
                    </Dropdown.Item>
                    <Dropdown.Item>{t('Edit post')}</Dropdown.Item>
                    <Dropdown.Divider />
                    <Dropdown.Item>{t('Delete')}</Dropdown.Item>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <div className={'dot-menu-wrapper '}>
                      <Dropdown.Item>{t('Copy link to post')}</Dropdown.Item>
                    </div>
                  </React.Fragment>
                )}
              </Dropdown.Menu>
            </Dropdown>
          )} */}
        </div>
      </div>
      {post.body && post.body.length > 0 && <PostDescription post={post} />}
      <LockedContent>
        {files[0] && files[0].mime_type === 'video' ? (
          <div className="d-flex mb-2 align-items-center">
            <SmallVideoIcon className={`video-hebrew`} />
            <span className="vedeo-image-heb ml-2">
              {files[0].duration === null ? '00:00' : convertMS(files[0].duration)}
            </span>
          </div>
        ) : files[0] && files[0].mime_type === 'image' ? (
          <div className="d-flex mb-2 align-items-center">
            <SmallImageIcon />
            <span className="vedeo-image-heb ml-2">{files.length > 0 ? files.length : null}</span>
          </div>
        ) : null}
        <FollowBtn />
      </LockedContent>
      <div className="d-flex mt-2 mb-2 post-actions-container">
        <div id={userStatus !== 'verified' && 'disabled-sub-section'} className="d-flex">
          <div >
            <PostActionItem
              icon={PostHeartIcon}
              customClass="like-icon-locked  like-disable-action mr-4"
              iconClass="text-gray"
              fill="#A6ABC9"
            />
          </div>
          <div >
            <PostActionItem icon={DisabledCommentDotsIcon} customClass="mr-4" fill="#A6ABC9" />
          </div>

          {show && <AddPaymentModal card={card} user={post.user} show={show} onHide={() => setShow(false)} />}

          <TipModal card={card} onSubmit={onSubmit} user={post.user} />
        </div>
      </div>
      <div>{`${post?.likes_count > 1 ? `${post?.likes_count} ${t('likes')}` : `${post?.likes_count} ${t('like')}`
        }`}</div>
      <div className="locked-sub-line"></div>
    </div>
  );
};

export default LockedSubscribeContent;
